import React from 'react';
import I18n from 'i18n-js';

import { useQuery } from '@reverbdotcom/commons/src/useQuery';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import { parseAmount } from '@reverbdotcom/commons/src/money';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { RCTooltip } from '@reverbdotcom/cadence/components';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { SellerHub_EarningsQuery, SellerHub_EarningsQueryVariables } from '@reverbdotcom/commons/src/gql/graphql';

import { SELLER_HUB_EARNINGS_QUERY, TimePeriodSelect } from '../../seller_hub/Earnings';
import { Paths } from '../../../components/shared/url_helpers';

interface IProps {
  timePeriod?: string;
  setTimePeriod?: (timePeriod: string) => void;
  showPayoutBalanceLink?: boolean;
}

export default function Earnings({ timePeriod, setTimePeriod, showPayoutBalanceLink = false }: IProps) {
  const user = useUser();
  const { data, loading } = useQuery<SellerHub_EarningsQuery, SellerHub_EarningsQueryVariables>(SELLER_HUB_EARNINGS_QUERY, {
    variables: { timePeriod },
  });

  const { earnings } = data?.me?.shop || {};
  const defaultAmount = parseAmount('0', user.currency);
  const earningsDefault = { ordersTotal: defaultAmount };
  const { ordersTotal } = earnings || earningsDefault;

  if (loading) {
    return (
      <div className="earnings-payouts__overview__earnings earnings-payouts__overview__earnings--loading"></div>
    );
  }

  return (
    <div className="earnings-payouts__overview__earnings">
      <div className="d-flex fx-dir-col">
        <TimePeriodSelect loading={loading} timePeriod={timePeriod} setTimePeriod={setTimePeriod} />
        <div className="seller-hub__earnings">
          <Translate text="sellerHub.earnings.youveEarned" />
          <RCTooltip
            text={<Translate text="sellerHub.earnings.tooltipText" />}
            type="underline"
          >
            <span className="seller-hub__earnings-amount">{ordersTotal.display}</span>
          </RCTooltip>
          <Translate text="sellerHub.earnings.onReverb" />
        </div>
        {showPayoutBalanceLink && (
          <CoreLink
            to={Paths.myEarningsPayoutBalance.expand({})}
            className="mt-4 fg-color-text-primary td-underline text-utility-350"
          >
            {I18n.t('earnings.payouts.overview.seeMyPayoutBalance')}
          </CoreLink>
        )}
      </div>
    </div>
  );
}
